export const ROLE_PERMISSIONS: Record<string, string[]> = {
  admin: [
    // Content Management
    'view_questions',
    'create_questions',
    'edit_own_questions',
    'edit_all_questions',
    'delete_questions',
    'upload_pdf',
    'validate_chunks',
    'approve_questions',
    // Compliance
    'compliance_review',
    'manage_regulations',
    'view_audit_logs',
    // Testing
    'take_tests',
    'generate_tests',
    // Analytics
    'view_analytics',
    'export_analytics',
    // AI & Agents
    'view_agent_traces',
    'view_cost_metrics',
    'debug_agents',
    'manage_mcp_servers',
    'configure_pipeline',
    // Editorial Workflow (NWFE-RQ-01)
    'review_task_view',
    'review_stage_1',
    'review_stage_2',
    'review_assign',
    'ai_review_monitor',
    'prompt_manage',
    'salesforce_publish',
  ],
  super_admin: [
    // All permissions
    'view_questions',
    'create_questions',
    'edit_own_questions',
    'edit_all_questions',
    'delete_questions',
    'upload_pdf',
    'validate_chunks',
    'approve_questions',
    'compliance_review',
    'manage_regulations',
    'view_audit_logs',
    'take_tests',
    'generate_tests',
    'view_analytics',
    'export_analytics',
    'view_agent_traces',
    'manage_mcp_servers',
    'debug_agents',
    'configure_pipeline',
    'view_cost_metrics',
    'manage_users',
    'system_config',
    'manage_system',
    // Editorial Workflow (NWFE-RQ-01)
    'review_task_view',
    'review_stage_1',
    'review_stage_2',
    'review_assign',
    'ai_review_monitor',
    'prompt_manage',
    'salesforce_publish',
  ],
  // Editorial reviewer roles (NWFE-RQ-01) — see the task queue, act only at
  // their own stage
  linguist: [
    'review_task_view',
    'review_stage_1',
    'view_questions',
  ],
  professor: [
    'review_task_view',
    'review_stage_2',
    'view_questions',
  ],
};

export const ROLE_LABELS: Record<string, string> = {
  admin: 'Admin',
  super_admin: 'Super Admin',
  linguist: 'Linguist (Stage 1 reviewer)',
  professor: 'Professor (Stage 2 reviewer)',
};
